/** Card de secao numerada do dialog de item de estoque. O titulo e' a pergunta
 *  inteira ("Como voce compra este item?") — sem rotulo lateral repetindo. */
export default function Secao({ numero, titulo, ajuda, children, testId }) {
  return (
    <section className="rounded-xl border bg-card/60 p-4" data-e2e={testId}>
      <header className="flex items-center gap-2.5 mb-3">
        <span className="inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary text-[12px] font-bold text-primary-foreground tabular-nums">{numero}</span>
        <div className="min-w-0">
          <h4 className="text-sm font-semibold leading-tight">{titulo}</h4>
          {ajuda && <p className="text-xs text-muted-foreground mt-0.5">{ajuda}</p>}
        </div>
      </header>
      <div className="space-y-3">{children}</div>
    </section>
  );
}
